import * as t from 'io-ts';
import {DragEvent} from 'react';

import {makeDragAndDropJson} from '../../../helpers/dragAndDropHelpers';
import {RUploadedAttachment} from '../../../models/api/attachmentModel';

export enum DraggedAttachmentItemTypesEnum {
  UPLOADED_ATTACHMENTS = 'uploaded_attachments',
  MESSAGES = 'messages',
}

const RDraggedMessage = t.type({
  messageUid: t.string,
  emlFileName: t.string,
});

export interface DraggedMessageItemModel extends t.TypeOf<typeof RDraggedMessage> {}

const RDraggedMessages = t.type({
  type: t.literal(DraggedAttachmentItemTypesEnum.MESSAGES),
  messages: t.readonlyArray(RDraggedMessage),
});

const RDraggedUploadedAttachments = t.type({
  type: t.literal(DraggedAttachmentItemTypesEnum.UPLOADED_ATTACHMENTS),
  attachments: t.readonlyArray(RUploadedAttachment),
});

export const RDraggedAttachmentItems = t.union([RDraggedMessages, RDraggedUploadedAttachments]);

export interface DraggedMessagesModel extends t.TypeOf<typeof RDraggedMessages> {}
export interface DraggedUploadedAttachmentsModel extends t.TypeOf<typeof RDraggedUploadedAttachments> {}

export type DraggedAttachmentItemsModel = DraggedMessagesModel | DraggedUploadedAttachmentsModel;

export function addNativeAttachmentsToDragEvent(e: DragEvent, items: DraggedAttachmentItemsModel) {
  if (!e.nativeEvent.dataTransfer) {
    return;
  }

  e.nativeEvent.dataTransfer.setData('x-front-attachment', makeDragAndDropJson(items));
}
